export default {
  h1_services: "Artificial Intelligence Services for Doctors",
  Services: "Products",
  eduServices: "Courses",
  AIServices: "Products",
  mg: "Mammography",
  dx: "Chest X-Ray",
  // rf: "Chest XR",
  "Go to service": "Try",
  "Service banner text":
    "Calculate the cost savings from AI in your institution",
  Calc: "Try",
  "Services title": "Products | " + process.env.VUE_APP_INSTALL_NAME + "",
  "No description service": "Description not found",
  "Services cannot loading": "Service temporarily unavailable. Try again later",
  "Cash calc title":
    "Cost calculator | " + process.env.VUE_APP_INSTALL_NAME + "",
  "Cash calc": "Cost calculator",
  "Cash calc desc": "How much costs you can save with AI",
  "Cash calc desc about":
    "Enter data for your institution. The data will be deleted after exiting the calculator.",
  "Average cash": "Average salary of a radiologist per month",
  "Study calc count": "Number of studies at your institution per month",
  mmg: "Mammography",
  ddx: "Chest X-ray",
  ct: "Chest CT",
  "Start calc": "Calculate",
  economy: "Savings",
  rub: " $",
  "calc time": " h",
  "Calc summary": "Total annually",
  "Without AI": "Without AI",
  "With AI": "With AI",
  "Count calc short": "Annual number of ",
  "Calc in Year": "",
  "Calc item 1": "Reading time <br /> per study, min",
  "Calc item 2": "Reading cost <br /> per study, $",
  "Calc item 3": "Reading costs <br />",
  "Calc item 4": "Reading time,<br />h",
  mmg__count: "MMG",
  ddx__count: "CXR",
  ct__count: "CT",
  "Calc info": "Calculation methodology",
};
